import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = "online_course";

export type onlineCourseTagList = {
    keyword?: string;
    start_date?: string;
    end_date?: string;
    type?: string;
    status?: string;
    limit?: number;
    page?: number;
}
export type onlineCourseTypeList = {
    keyword?: string;
    start_date?: string;
    end_date?: string;
    type?: string;
    status?: string;
    limit?: number;
    page?: number;
}
export type onlineCourseFormList = {
    online_course_form_type?: string;
    keyword?: string;
    start_date?: string;
    end_date?: string;
    type?: string;
    status?: string;
    limit?: number;
    page?: number;
}
export type onlineCourseTag = {
    online_course_tag: string;
}
export type onlineCourseType = {
    online_course_type: string;
}

export type OnlineCourseForm = {
    online_course_form_name: string;
    online_course_form_status: string;
    online_course_form_type: string;
    course_form_subject: {
        id_online_course_form_subject: number | null;
        online_course_form_subject_type: "SINGLE_CHOICE" | "MULTIPLE_CHOICE" | string; // you can adjust possible types
        require_answer: number; // or boolean if you prefer
        online_course_form_subject_point: number | null;
        online_course_form_subject: string;
        choices: {
            id_online_course_form_choice: number | null;
            online_course_form_choice_type: string;
            online_course_form_choice: string;
            online_course_form_choice_true: number; // or boolean
            online_course_form_choice_point: number;
        }[];
    }[];
};

export type chartStatisticsData = {
    start_date?: string;
    end_date?: string;
    type_user?: string;
}

export class OnlineCourseApi extends BaseAPI {
    static tagsList(params: onlineCourseTagList): Promise<AxiosResponse> {
        return this.api.get(`${path}_tag`, { params: { ...params } })
    }
    static createTag(body: onlineCourseTag): Promise<AxiosResponse> {
        return this.api.post(`${path}_tag`, body)
    }
    static updateTag(id_online_course_tag: number, body: onlineCourseTag): Promise<AxiosResponse> {
        return this.api.patch(`${path}_tag/${id_online_course_tag}`, body)
    }
    static findOneTag(id_online_course_tag: number): Promise<AxiosResponse> {
        return this.api.get(`${path}_tag/${id_online_course_tag}`)
    }
    static deleteTag(id_online_course_tag: number): Promise<AxiosResponse> {
        return this.api.delete(`${path}_tag/${id_online_course_tag}`)
    }
    static typeList(params: onlineCourseTagList): Promise<AxiosResponse> {
        return this.api.get(`${path}_type`, { params: { ...params } })
    }
    static createType(body: onlineCourseType): Promise<AxiosResponse> {
        return this.api.post(`${path}_type`, body)
    }
    static updateType(id_online_course_tag: number, body: onlineCourseType): Promise<AxiosResponse> {
        return this.api.patch(`${path}_type/${id_online_course_tag}`, body)
    }
    static findOneType(id_online_course_tag: number): Promise<AxiosResponse> {
        return this.api.get(`${path}_type/${id_online_course_tag}`)
    }
    static deleteType(id_online_course_tag: number): Promise<AxiosResponse> {
        return this.api.delete(`${path}_type/${id_online_course_tag}`)
    }
    static formList(params: onlineCourseFormList): Promise<AxiosResponse> {
        return this.api.get(`${path}_form`, { params: { ...params } })
    }
    static createForm(body: OnlineCourseForm): Promise<AxiosResponse> {
        return this.api.post(`${path}_form`, body)
    }
    static updateForm(id_online_course_form: number, body: OnlineCourseForm): Promise<AxiosResponse> {
        return this.api.patch(`${path}_form/${id_online_course_form}`, body)
    }
    static findOneForm(id_online_course_form: number): Promise<AxiosResponse> {
        return this.api.get(`${path}_form/${id_online_course_form}`)
    }
    static deleteForm(id_online_course_form: number): Promise<AxiosResponse> {
        return this.api.delete(`${path}_form/${id_online_course_form}`)
    }
    static getChart(query: chartStatisticsData): Promise<AxiosResponse> {
        return this.api.get(`chart-online-course`, { params: { ...query } })
    }
    static getChartFile(query: chartStatisticsData): Promise<AxiosResponse> {
        return this.api.get(`chart-online-course-file`, { params: { ...query }, responseType: "arraybuffer", })
    }
}